"use client"

import { memo } from "react"
import { catColor } from "@/lib/catColors"
import Link from "next/link"

const chipClassName = (size) =>
    `mr inline-block font-bold tracking-[0.04em] text-white uppercase rounded-xs whitespace-nowrap text-xs py-1 ${size === 'sm' ? 'px-2' : 'px-3'}`

const CategoryChip = ({ name, size = 'md', url = "" }) => {
    const chip = (
        <span
            className={chipClassName(size)}
            style={{ background: catColor(name) }}
        >
            {name}
        </span>
    )

    if (!url) return chip

    return (
        <Link href={url} className="inline-block">
            {chip}
        </Link>
    )
}

export default memo(CategoryChip)